import { useFormik } from 'formik';
import { RequirementComplianceProps } from '../requirementsCheck';
import { useAnswerRecorderMutation } from 'views/utils/graphql/graphql';
import { useGlobalToastHandler } from 'views/mutual/globalToast/hooks';
import { useGlobalLoadingHandler } from 'views/mutual/globalLoading/hook';
import * as Yup from 'yup';
import { AnswerRecorderType } from '../hooks';

// 要件適合の二値
export enum RequirementCompliance {
    Compliant = 1,       // 要件を満たす
    NonCompliant = 2, // 要件を満たさない
}

export type RequirementComplianceType = {
    requirementCompliance: RequirementCompliance | null;
}

export const useOverseasRealEstateRequirementsCheck = (navigate: () => void) => {
    const [ _, answerRecorder] = useAnswerRecorderMutation();
    const { showError, messageClose } = useGlobalToastHandler();
    const { showLoading, hideLoading } = useGlobalLoadingHandler();

    const validation = Yup.object().shape({
        requirementCompliance: Yup.number().not([RequirementCompliance.NonCompliant], '本事業へにご参加いただける法人は日本国の居住者に該当する法人に限定しており、非該当の場合はご参加いただけません。'),
      });

    const initialValues: RequirementComplianceType = {
        requirementCompliance: null,
    };

    const formik = useFormik<RequirementComplianceType>({
        enableReinitialize: false,
        initialValues,
        async onSubmit(input) {
            showLoading();
            const res = await answerRecorder({
                input: {
                    W8BenE: input.requirementCompliance,
                    Type: AnswerRecorderType.W8BenE,
                }
            });
            hideLoading();
            if (!res?.data) return;
            if (res.data.AnswerRecorder?.Code === 0) {
                navigate();
            } else {
                showError(res.data.AnswerRecorder?.Message);
            }
        },
        validationSchema: validation,
        validateOnChange: true,
        validateOnBlur: false,
        validate: () => {
            // バリデーションかける時に必ずエラートーストを閉じる
            messageClose();
        },
    });

    const requirementComplianceProps: RequirementComplianceProps = {
        selected: formik.values.requirementCompliance,
        onChange: (value: RequirementCompliance) => formik.setFieldValue('requirementCompliance', value),
        error: formik.errors.requirementCompliance,
    };
    
    const buttonDisabled = formik.values.requirementCompliance !== RequirementCompliance.Compliant;

    return{
        formik,
        requirementComplianceProps,
        buttonDisabled,
    }
};
